import { render, staticRenderFns } from "./PersonCreateForm.vue?vue&type=template&id=6b365740&"
import script from "./PersonCreateForm.vue?vue&type=script&lang=js&"
export * from "./PersonCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports